import { SvgIcon } from "@mui/material";
import Dashboard from "./pages/dashboard";
import Employeeonboarding from "./pages/onboarding/employeeonboarding";
import EmployeeManagement from "./pages/employeemanagement";
import ManagerManagement from "./pages/managermanagement";
import Department from "./pages/department";
import Designation from "./pages/designation";
import Payroll from "./pages/payroll";
import LeaveManagement from "./pages/leavemanagement";
import RegularizationRequest from "./pages/regularizationrequest";
import WFHManagemnt from "./pages/wfhmanagement";
import Attendance from "./pages/attendance";
import HomeIcon from "@mui/icons-material/Home";
import PersonIcon from "@mui/icons-material/Person";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import BadgeIcon from "@mui/icons-material/Badge";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AddHomeWorkIcon from "@mui/icons-material/AddHomeWork";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import AddEmployee from "./pages/employeemanagement/components/AddEmployee";
import Signin from "./pages/authentication/signin";
import AddCustomer from "./pages/customer/AddCustomer";
import CustomerListTable from "./pages/customer/CustomerListTable";
import NotificationsIcon from '@mui/icons-material/Notifications';
import VendorListTable from "./pages/vendor/VendorListTable";
import AddVendor from "./pages/vendor/AddVendor";
import { AddIcCall, Assignment, QueryStats, Shop } from "@mui/icons-material";
import AddManager from "./pages/managermanagement/components/AddManager";
import LeadAndProspect from "./pages/lead-and-prospect/LeadAndProspect";
import PrivateRoute from "./PrivateRoute/PrivateRoute";
import LeadAndProspectForm from "./pages/lead-and-prospect/LeadAndProspectForm";
import RoleListTable from "./pages/role/RoleListTable";
import AddEmployees from "./pages/employee/AddEmployees/AddEmployees";
import EmployeesListTable from "./pages/employee/EmployeesListTable";
import AddContact from "./pages/contact/AddContact";
import ContactListTable from "./pages/contact/ContactListTable";
import UomListTable from "./pages/uom/UomListTable";
import AddUom from "./pages/uom/AddUom";
import Appointment from "./pages/appointment/Appointment";
import AppointmentForm from "./pages/appointment/AppointmentForm";
import AddBrand from "./pages/brand/AddBrand/AddBrand";
import BrandListTable from "./pages/brand/BrandListTable";
import CategoryListTable from "./pages/category/CategoryListTable";
import AddCategory from "./pages/category/AddCategory/AddCategory";
import ProductListTable from "./pages/product/ProductListTable";
import AddProduct from "./pages/product/AddProduct/AddProduct";
import WareHouseListTable from "./pages/wareHouse/WareHouseListTable";
import AddWareHouse from "./pages/wareHouse/AddWareHouse";
import SaleStageListTable from "./pages/saleStage/SaleStageListTable";
import AddSaleStage from "./pages/saleStage/AddSaleStage";
import OpportunityTypeListTable from "./pages/opportunityType/OpportunityTypeListTable";
import AddOpportunityType from "./pages/opportunityType/AddOpportunityType/AddOpportunityType";
import OpportunityListTable from "./pages/opportunity/OpportunityListTable";
import AddOpportunity from "./pages/opportunity/AddOpportunity";
import QuationsListTables from "./pages/Quations/QuationsListTables";
import QuationsForm from "./pages/Quations/QuationsForm";
import { useAuth } from "./context/AuthContext/AuthContextProvider";
import QuoteStatus from "./pages/Quations/ChangeStatus/QuoteStatus";
import ConvertSalesOrder from "./pages/Quations/ChangeStatus/ConvertSalesOrder";
import HandleDownloadPdf from "./pages/Quations/convertPDF/HandleDownloadPdf";
import SalesTarget from "./pages/SalesTarget/SalesTarget";
import AddSalesTarget from "./pages/SalesTarget/AddSalesTarget";
import SinglePersonTarget from "./pages/SalesTarget/SinglePersonTarget";
import CrisisAlertIcon from "@mui/icons-material/CrisisAlert";
import TimelineIcon from "@mui/icons-material/Timeline";
import ViewMonthlyTarget from "./pages/SalesTarget/ViewMonthlyTarget";
import UpdateMonthlyTarget from "./pages/SalesTarget/UpdateMonthlyTarget";
import ViewYearlyTarget from "./pages/SalesTarget/ViewYearlyTarget";
import EmployeeViewTarget from "./pages/SalesTarget/employee/EmployeeViewTarget";
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import FlagCircleIcon from '@mui/icons-material/FlagCircle';
import TargetReport from "./pages/targetReport/TargetReport";
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import CallListTable from "./pages/conversation/Call/CallListTable";
import VisitListTable from "./pages/conversation/visit/VisitListTable";
import AddCall from "./pages/conversation/Call/AddCall/AddCall";
import MailListTable from "./pages/conversation/mail/MailListTable";
import AddMail from "./pages/conversation/mail/AddMail";
import AddVisit from "./pages/conversation/visit/AddVisit";
import SalesListTable from "./pages/SalesOrder/SalesListTable";
import AddSalesOrder from "./pages/SalesOrder/AddSalesOrder";
import PricingListTable from "./pages/pricing/table";
import AddPricing from "./pages/pricing/pricing";
import Projectestimatetable from "./pages/projectestimate/table";
import AddEstimate from "./pages/projectestimate/Addestimate";
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';

import NewQuationPdf from "./pages/pdf/quationpdf/NewQuationPdf";


import DashboardIcon from '@mui/icons-material/Dashboard';
import ChatIcon from '@mui/icons-material/Chat';
import PeopleIcon from '@mui/icons-material/People';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import SettingsIcon from '@mui/icons-material/Settings';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import WhatsAppLogList from "./pages/conversation/Whatsapp/ListWhatsappLog";
import AddWhatsappLog from "./pages/conversation/Whatsapp/AddWhatsappLog";
import Addtaskcreation from "./pages/Task Creation/Component";
import TaskCreationList from "./pages/Task Creation";
import TaskStatusMonitoring from "./pages/taskManagement/AddTaskStatusMonitoring";
import AddTaskStatusMonitoring from "./pages/taskManagement/AddTaskStatusMonitoring";
import TaskStatusMonitoringList from "./pages/taskManagement";
import NotificationList from "./pages/notification";
import AddNotification from "./pages/notification/AddNotification";
import AddRole from "./pages/role/AddRole/AddRole";
import AuthLoader from "./pages/authentication/signin/authLoader";

const routes = [
  {
    name: "Authentication",
    key: "authentication",
    collapse: [
      {
        name: "Sign in",
        key: "sign-in",
        route: "/authentication",
        component: <AuthLoader />,
      },
      {
        name: "Sign in",
        key: "sign-in",
        route: "/sign-in",
        component: <Signin />,
      },
    ],
  },
  {
    name: "Onboarding",
    key: "onboarding",
    collapse: [
      {
        name: "Employee Onboarding",
        key: "employee-onboarding",
        route: "/employeeonboarding",
        component: <Employeeonboarding />,
      },
    ],
  },
  {
    type: "collapse",
    icon: <DashboardIcon  />,
    // <SvgIcon viewBox="0 0 400 320" style={{ width: '15px' }} >
    //     <path d="M3.375 3C2.339 3 1.5 3.84 1.5 4.875v.75c0 1.036.84 1.875 1.875 1.875h17.25c1.035 0 1.875-.84 1.875-1.875v-.75C22.5 3.839 21.66 3 20.625 3H3.375Z" />
    //     <path fill-rule="evenodd" d="m3.087 9 .54 9.176A3 3 0 0 0 6.62 21h10.757a3 3 0 0 0 2.995-2.824L20.913 9H3.087ZM12 10.5a.75.75 0 0 1 .75.75v4.94l1.72-1.72a.75.75 0 1 1 1.06 1.06l-3 3a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 1 1 1.06-1.06l1.72 1.72v-4.94a.75.75 0 0 1 .75-.75Z" clip-rule="evenodd" />
    // </SvgIcon>,
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    component: <Dashboard />,
    noCollapse: true,
    protected: true,
  },

  {
    type: "collapse",
    name: "Masters",
    key: "masters",
    icon: <Shop size="12px" />,
    collapse: [
      {
        name: "Brand",
        key: "brand",
        route: "/brand",
        component: <BrandListTable />,
      },
      {
        name: "Role",
        key: "role",
        route: "/role",
        component: <RoleListTable />,
      },
      {
        name: "Employee",
        key: "employee",
        route: "/employee",
        component: <EmployeesListTable 
        />,
      },

      // {
      //   name: "Contact",
      //   key: "contact",
      //   route: "/contact",
      //   component: <ContactListTable />,
      // },
      {
        name: "Category",
        key: "category",
        route: "/category",
        component: <CategoryListTable />,
      },
      {
        name: "UOM",
        key: "uom-management",
        route: "/uom",
        icon:<PersonIcon />,
        component: <UomListTable />,
      },
      {
        name: "Product",
        key: "product",
        route: "/product",
        component: <ProductListTable />,
      },

      // {
      //   name: "Pricing",
      //   key: "pricing",
      //   route: "/pricing",
      //   component: <PricingListTable />,
      // },
      {
        name: "WareHouse",
        key: "wareHouse",
        route: "/wareHouse",
        component: <WareHouseListTable />,
      },
      {
        name: "OpportunityType",
        key: "opportunityType",
        route: "/opportunityType",
        component: <OpportunityTypeListTable />,
      },
      
      // {
      //   name: "Sales Stage",
      //   key: "salesStage",
      //   route: "/salesStage",
      //   component: <SaleStageListTable />,
      // },

      // {
      //     type: "collapse",
      //     icon: <PersonIcon />,
      //     name: "Employee Management",
      //     key: "employee-management",
      //     route: "/employee-management",
      //     component: <EmployeeManagement />,
      //     noCollapse: true,
      //     protected: true,
      // },
      // {
      //     type: "AddEmployee",
      //     key: "add-employee",
      //     route: "/employee-management/add-employee",
      //     component: <AddEmployee />,
      //     protected: true,
      // },

      // {
      //   type: "collapse",
      //   icon: <PersonIcon />,
      //   name: "Employee",
      //   key: "employee",
      //   route: "/employee",
      //   component: <EmployeesListTable />,
      //   noCollapse: true,
      //   protected: true,
      // },
    ],
  },
  {
  type: "collapse",
  name: "Conversation",
  key: "conversation",
  icon: <ChatIcon size="12px" />,
  collapse:[
    {
      name: "Call Log",
      key: "calldetails",
      route: "/call-details",
      component:<CallListTable/>
    },
    {
      name: "Mail Log",
      key: "maildetails",
      route: "/maildetails",
      component: <MailListTable/>
    },
    {
      name: "Visit Log",
      key: "visitdetails",
      route: "/visitdetails",
      component: <VisitListTable/>
    },

    {
      name: "WhatsApp Log",
      key: "whatsappdetails",
      route: "/whatsapplog",
      component: <WhatsAppLogList/>
    }

  ],
  },
  // {
  //     type: "collapse",
  //     name: "Dashboards",
  //     key: "dashboards",
  //     icon: <Shop size="12px" />,
  //     collapse: [
  //         {
  //             name: "Default",
  //             key: "default",
  //             route: "/dashboards/default",
  //             component: <EmployeeManagement />,
  //         },
  //         {
  //             name: "Automotive",
  //             key: "automotive",
  //             route: "/dashboards/automotive",
  //             component: <EmployeeManagement />,
  //         },
  //         {
  //             name: "Smart Home",
  //             key: "smart-home",
  //             route: "/dashboards/smart-home",
  //             component: <EmployeeManagement />,
  //         },
  //         { name: "CRM", key: "crm", route: "/dashboards/crm", component: <EmployeeManagement /> },
  //     ],
  // },
  // {
  //     type: "collapse",
  //     icon: <PersonIcon />,
  //     name: "Employee Management",
  //     key: "employee-management",
  //     route: "/employee-management",
  //     component: <EmployeeManagement />,
  //     noCollapse: true,
  //     protected: true,
  // },
  // {
  //     type: "AddEmployee",
  //     key: "add-employee",
  //     route: "/employee-management/add-employee",
  //     component: <AddEmployee />,
  //     protected: true,
  // },
  {
    type: "collapse",
    icon: <LeaderboardIcon />,
    name: "Prospect",
    key: "prospect",
    route: "/prospect",
    component: <LeadAndProspect />,
    noCollapse: true,
    protected: true,
  },
  // {
  //   type: "collapse",
  //   icon: <PersonIcon />,
  //   name: "Vendor",
  //   key: "vendor",
  //   route: "/vendor",
  //   component: <VendorListTable />,
  //   noCollapse: true,
  //   protected: true,
  // },
  {
    type: "collapse",
    icon: <SupportAgentIcon />,
    name: "Customer 360",
    key: "customer-360",
    route: "/customer-360",
    component: <CustomerListTable />,
    noCollapse: true,
    protected: true,
  },
  {
    type: "collapse",
    icon: <ContactPhoneIcon />,
    name: "Contact",
    key: "contact",
    route: "/contact",
    component: <ContactListTable />,
    noCollapse: true,
    protected: true,
  },
  {
    type: "AddCustomer",
    key: "add-customer",
    route: "/customer-360/add-customer",
    component: <AddCustomer />,
    protected: true,
    isShow: true,
  },

  
  {
    type: "AddVendor",
    key: "add-vendor",
    route: "/vendor/add-vendor",
    component: <AddVendor />,
    protected: true,
    isShow: true,
  },
  {
    type: "showTarget",
    key: "showTarget",
    route: "/SalesTarget/showTarget",
    component: <EmployeeViewTarget />,
    protected: true,
    isShow: true,
  },
  {
    type: "collapse",
    icon: <AssignmentTurnedInIcon />,
    name: "Opportunity",
    key: "opportunity",
    route: "/opportunity",
    component: <OpportunityListTable />,
    noCollapse: true,
    protected: true,
  },
  {
    type: "collapse",
    icon: <TimelineIcon />,
    name: "Appointment",
    key: "appointment",
    route: "/appointment",
    component: <Appointment />,
    noCollapse: true,
    protected: true,
  },
  {
    type: "AddOpportunity",
    key: "opportunity",
    route: "/opportunity/add-opportunity",
    component: <AddOpportunity />,
    protected: true,
    isShow: true,
  },

  // {
  //   type: "collapse",
  //   icon: <MonetizationOnIcon />,
  //   name: "Project Estimate",
  //   key: "project-Estimate",
  //   route: "/project-Estimate",
  //   component: <Projectestimatetable />,
  //   noCollapse: true,
  //   protected: true,
  // },
  // {
  //   type: "AddEstimate",
  //   key: "project-estimate",
  //   route: "/project-Estimate/add-Estimate",
  //   component: <AddEstimate />,
  //   protected: true,
  // },
  {
    type: "collapse",
    icon: <HistoryEduIcon />,
    name: "Quotation",
    key: "quotation",
    route: "/quotation",
    component: <QuationsListTables />,
    noCollapse: true,
    protected: true,
  },
  {
    type: "AddQuotation",
    key: "quotation",
    route: "/quotation/add-quotation",
    component: <QuationsForm />,
    protected: true,
    isShow: true,
  },
  {
    type: "editQuotation",
    key: "quotation",
    route: "/quotation/edit-quotation",
    component: <QuationsForm />,
    protected: true,
    isShow: true,
  },
  {
    type: "ViewQuotation",
    key: "quotation",
    route: "/quotation/view-quotation",
    component: <QuationsForm />,
    protected: true,
    isShow: true,
  },

  {
    type: "AddAppointment",
    key: "addappointment",
    route: "/appointment/addappointment",
    component: <AppointmentForm />,
    protected: true,
    isShow: true,
  },

  {
    type: "EditAppointment",
    key: "editappointment",
    route: "/appointment/editappointment/:id",
    component: <AppointmentForm />,
    protected: true,
    isShow: true,
  },
  // {
  //   type: "collapse",
  //   icon: <FlagCircleIcon />,
  //   name: "Sales Order",
  //   key: "sales-order",
  //   route: "/sales-order",
  //   component: <SalesListTable/>,
  //   noCollapse: true,
  //   protected: true,
  // },
  {
    type: "collapse",
    icon: <CrisisAlertIcon />,
    name: "SalesTarget",
    key: "SalesTarget",
    route: "/SalesTarget",
    component: <SalesTarget />,
    noCollapse: true,
    protected: true,
  },
  {
    type: "collapse",
    icon: <FlagCircleIcon />,
    name: "Target Report",
    key: "TargetReport",
    route: "/TargetReport",
    component: <TargetReport />,
    noCollapse: true,
    protected: true,
  },
  {
    type: "AddProspect",
    key: "add-Prospect",
    route: "/prospect/add-Prospect",
    component: <LeadAndProspectForm />,
    protected: true,
    isShow: true,
  },
  {
    type: "EditProspect",
    key: "edit-Prospect",
    route: "/prospect/editProspect/:id",
    component: <LeadAndProspectForm />,
    protected: true,
    isShow: true,
  },

  {
    type: "AddRole",
    key: "add-role",
    route: "/role/add-role",
    component: <AddRole />,
    protected: true,
    isShow: true,
  },
  // {
  //   type: "AddSalesorder",
  //   key: "addsalesorder",
  //   route: "/sales-Order/addsalesorder",
  //   component: <AddSalesOrder />,
  //   protected: true,
  // },
  {
    type: "AddRole",
    key: "add-role",
    route: "/SalesTarget/ViewMonthlyTarget",
    component: <ViewMonthlyTarget />,
    protected: true,
    isShow: true,
  },
  {
    type: "AddRole",
    key: "add-role",
    route: "/SalesTarget/updateMonthlyTarget",
    component: <UpdateMonthlyTarget />,
    protected: true,
    isShow: true,
  },
  {
    type: "AddUOM",
    key: "add-uom",
    route: "/uom/add-uom",
    component: <AddUom />,
    protected: true,
    isShow: true,
  },
  {
    type: "AddBrand",
    key: "add-brand",
    route: "/brand/add-brand",
    component: <AddBrand />,
    protected: true,
    isShow: true,
  },
  {
    type: "AddContact",
    key: "add-contact",
    route: "/contact/add-contact",
    component: <AddContact />,
    protected: true,
    isShow: true,
  },
  {
    type: "AddCategory",
    key: "add-category",
    route: "/category/add-category",
    component: <AddCategory />,
    protected: true,
    isShow: true,
  },
  {
    type: "AddProduct",
    key: "add-product",
    route: "/product/add-product",
    component: <AddProduct />,
    protected: true,
    isShow: true,
  },
  // {
  //   type: "AddPricing",
  //   key: "add-pricing",
  //   route: "/pricing/add-pricing",
  //   component: <AddPricing />,
  //   protected: true,
  // },
  {
    type: "AddWareHouse",
    key: "add-wareHouse",
    route: "/wareHouse/add-wareHouse",
    component: <AddWareHouse />,
    protected: true,
    isShow: true,
  },
  {
    type: "AddOpportunityType",
    key: "add-opportunityType",
    route: "/opportunityType/add-opportunityType",
    component: <AddOpportunityType />,
    protected: true,
    isShow: true,
  },
  // {
  //   type: "AddSaleStage",
  //   key: "add-saleStage",
  //   route: "/salesStage/add-saleStage",
  //   component: <AddSaleStage />,
  //   protected: true,
  // },
  {
    type: "Changestatus",
    key: "changestatus",
    route: "/quotation/changestatus",
    component: <QuoteStatus />,
    protected: true,
    isShow: true,
  },
  {
    type: "AddSalesTarget",
    key: "AddSalesTarget",
    route: "/SalesTarget/AddSalesTarget",
    component: <AddSalesTarget />,
    protected: true,
    isShow: true,
  },
  {
    type: "AddSalesTarget",
    key: "AddSalesTarget",
    route: "/SalesTarget/updateSalesTarget",
    component: <AddSalesTarget />,
    protected: true,
    isShow: true,
  },
  {
    type: "singlepersontarget",
    key: "Singlepersontarget",
    route: "/SalesTarget/singlepersontarget",
    component: <SinglePersonTarget />,
    protected: true,
    isShow: true,
  },
  {
    type: "singlepersontarget",
    key: "Singlepersontarget",
    route: "/SalesTarget/ViewYearlyTarget",
    component: <ViewYearlyTarget />,
    protected: true,
    isShow: true,
  },
  {
    type: "Convert Sales Order",
    key: "Convert Sales Order",
    route: "/quotation/convertsalesorder",
    component: <ConvertSalesOrder />,
    protected: true,
    isShow: true,
  },
  {
    type: "AddEmployee",
    key: "add-employee",
    route: "/employee/add-employees",
    component: <AddEmployees />,
    protected: true,
    isShow: true,
  },
  {
    type: "PdfDownload",
    key: "pdfdownload",
    route: "/quotation/:id",
    component: <NewQuationPdf />,
    protected: true,
    isShow: true,
  },
  // {
  //   type: "pdfdownload",
  //   key: "pdfdownload",
  //   route: "/quotation/pdfdownload/:id",
  //   component: <HandleDownloadPdf />,
  //   protected: true,
  // },

  {
    type: "AddCall",
    key: "add-call",
    route: "/call-details/add-call",
    component:<AddCall/>,
    protected: true,
    isShow: true,
  },

  {
    type: "AddWhatsappLog",
    key: "add-whatsapp",
    route: "/whatsapplog/add-whatsapp",
    component:<AddWhatsappLog/>,
    protected: true,
    isShow: true,
  },
  {
    type: "AddMail",
    key: "add-mail",
    route: "/maildetails/add-mail",
    component:<AddMail/>,
    protected: true,
    isShow: true,
  },
  {
    type: "AddVisit",
    key: "add-visit",
    route: "/visitdetails/add-visit",
    component:<AddVisit/>,
    protected: true,
    isShow: true,
  },
  {
    type: "collapse",
    icon: <Assignment />,
    name: "Task Creation",
    key: "taskcreation",
    route: "/taskcreation",
    component: <TaskCreationList />,
    allow:["Manager", "superuser"],
    noCollapse: true,
    protected: true,
  },
  {
    type: "AddTaskCreation",
    key: "addtaskcreation",
    route: "/taskcreation/addtaskcreation",
    component: <Addtaskcreation />,
    protected: true,
    allow:["Manager", "superuser"],
    isShow: true,
  } 
  ,
  {
    type: "collapse",
    icon: <QueryStats />,
    name: "Task Progress",
    key: "taskstatusmonitoring",
    route: "/taskstatusmonitoring",
    component: <TaskStatusMonitoringList />,
    noCollapse: true,
    protected: true,
  },
  {
    type: "AddTaskStatusMonitoring",
    key: "add-Task-Status-Monitoring",
    route: "/taskstatusmonitoring/add-Task-Status-Monitoring",
    component: <AddTaskStatusMonitoring />,
    protected: true,
    isShow: true,
  },
  {
    type: "collapse",
    icon: <NotificationsIcon />,
    name: "Notification",
    key: "notification",
    route: "/notification",
    component: <NotificationList />,
    noCollapse: true,
    protected: true,
  },
  {
    type: "AddNotication",
    key: "view-notification",
    route: "/notification/view-notification",
    component: <AddNotification />,
    protected: true,
    isShow: true,
  },
  // {
  //   type: "collapse",
  //   name: "Quatations",
  //   key: "quatations",
  //   icon: <Shop size="12px" />,
  //   collapse: [
  //     {
  //       name: "Quatation",
  //       key: "quatation",
  //       route: "/dashboards/default",
  //       component: <EmployeeManagement />,
  //     },
  //     {
  //       name: "QuatationType",
  //       key: "quatationType",
  //       route: "/dashboards/default",
  //       component: <EmployeeManagement />,
  //     },
  //   ],
  // },
];
export default routes;
